import * as types from '../../constants';

const initialState = [];

export function professionalServicesDesign(state = initialState, action) {
  switch (action.type) {
    case types.GET_PROFESSIONAL_SERVICES_DESIGN_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
